// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"92aa4e65","800":"29889829"}[chunkId] + ".chunk.css";
};